import { SlashIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import { factory } from '../../factory/factory.utils.mjs';
import { Typography } from '../../Foundations/Typography/Typography.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import classes from './CarouselCounter.module.css.mjs';

const CarouselCounter = factory((props, ref) => {
  const { current, total, className, ...rest } = props;
  const classNames = clsx("kohler-carousel-counter-root", className, classes.root);
  return /* @__PURE__ */ React.createElement(Box, { className: classNames, ref, ...rest }, /* @__PURE__ */ React.createElement(Typography, { className: classes.currentNumber, component: "span", size: "h5" }, current), /* @__PURE__ */ React.createElement(SlashIcon, { size: "large", withBoundingBox: true }), /* @__PURE__ */ React.createElement(Typography, { className: classes.totalNumber, component: "span", size: "h5" }, total));
});

export { CarouselCounter };
